
























































































































































































import { GeneralMixin } from "@/mixins/general-mixin";
import mixins from "vue-typed-mixins";
import DateModal from "@/components/date-modal.vue";
import FormModal from "@/components/general/form-modal.vue";
import EquipmentCaractModal from "@/components/equipment-caract-modal.vue";
import EquipmentDetailsModal from "@/components/equipment-details-modal.vue";
import solidButton from "../general/solid-button.vue";
import config from "@/config";

export interface Device {
  device_category: number;
  device_manufacture_display_name: string;
  device_manufacture_id: number;
  device_type_id: number;
  device_type_key?: string;
  device_type_name: string;
  device_form_link_id: string;
  friendly_name: string;
  id: number;
  sensor: string;
  state: number;
  updated: string;
}

export default mixins(GeneralMixin).extend({
  components: {
    solidButton,
    DateModal,
    FormModal,
    EquipmentCaractModal,
    EquipmentDetailsModal,
  },
  name: "EquipmentsList",
  props: ["cardTitle", "roughEdges", "monitorInfo"],
  data() {
    return {
      equipmentDetails: null,
      actions: [
        {
          action: "displayDetailsModal",
          title: "Obter Dados",
          color: "#646464",
          icon: "mdi-eye-plus-outline",
        },
        {
          action: "displayFormModal",
          title: "Caracterizar",
          color: "#646464",
          icon: "mdi-square-edit-outline",
        },
        {
          action: "displayDateModal",
          title: "Ver Detalhes",
          color: "#3bbbc8",
          icon: "mdi-download",
        },
      ],
    };
  },
  computed: {
    characterizationForms: {
      get(): any {
        return this.$store.getters["formsData/devices_characterization"];
      },
    },
    devices: function (): any {
      const mappedDevices = this.monitorInfo?.devices?.map((device: Device) => {
        return {
          ...device,
          device_type_name: `${this.$t(
            `devices.${device.device_type_name
              ?.toLowerCase()
              ?.normalize("NFD")
              ?.replaceAll(" ", "_")
              ?.replace(/[\u0300-\u036f]/g, "")}`
          )}`,
          device_form_link_id: this.getFormLinkForEquipment(device),
        };
      });
      return mappedDevices;
    },
  },
  methods: {
    onHandleAction(action: string, device: Device): void {
      if (action == "displayDetailsModal") {
        this.displayDetailsModal(device);
        return;
      }
      if (action == "displayFormModal") {
        this.displayFormModal(device);
        return;
      }
      if (action == "displayDateModal") {
        this.displayDateModal(true, device?.id);
        return;
      }
    },
    getFormLinkForEquipment(device: Device): string {
      if (!device?.device_type_name || !this.characterizationForms) return "";

      const formIdTag = config.deviceCharacterizationMappings.find(
        (mapping: {
          formIdTag: string;
          deviceId: number;
          deviceName: string;
        }) => {
          return (
            mapping.deviceId === device?.device_type_id ||
            mapping.deviceName?.toLocaleLowerCase() ===
              device?.device_type_name?.toLocaleLowerCase()
          );
        }
      )?.formIdTag;

      const form = this.characterizationForms.find(
        ({ id_tag }: { id_tag: string }) => {
          if (!formIdTag) return;
          return id_tag?.toLowerCase().includes(formIdTag?.toLocaleLowerCase());
        }
      );

      return form?.link_id;
    },
    displayFormModal(device: Device): void {
      const { id } = device;

      this.$store.commit("toggleModalState", {
        name: `equipment_characterization_${id}`,
        status: true,
      });
      this.$store.commit("formRecord/updateSensorId", id);
    },
    displayDetailsModal(device: Device): void {
      const { id } = device;
      this.$store.commit("toggleModalState", {
        name: `equipment_details_${id}`,
        status: true,
      });
      this.$store.commit("formRecord/updateSensorId", id);
    },
    isButtonDisabled(action: string, device: Device): boolean {
      return (
        (action === "displayFormModal" || action === "displayDetailsModal") &&
        !device.device_form_link_id
      );
    },
    getDeviceState(device: Device): string {
      if (device) {
        const { state } = device;

        if (state === 0) return `${this.$t("devices.status.offline")}`;
        if (state === 1) return `${this.$t("devices.status.operational")}`;
        if (state === 2) return `${this.$t("devices.status.semi-operational")}`;
      }

      return "-";
    },
    async getDeviceForm(deviceFormLink: string, sensor: string | number) {
      if (deviceFormLink === "") return;

      this.$store.commit("formRecord/updateFormLoadingStatus", true);
      await this.$store.dispatch("formRecord/getActiveForm", deviceFormLink);
      this.$store.commit("formRecord/updateFormLoadingStatus", false);
    },
  },
});
